// extracted by mini-css-extract-plugin
export default {"card":"Card_card__ERqMK","img":"Card_img__DiUj2","content":"Card_content__I6Q0Q","arrowBtn":"Card_arrowBtn__S1Tjv"};